import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import api from '../../api'; // Assuming you have an Axios instance configured

const baseURL = process.env.REACT_APP_API_URL;

const NetworkStatus = ({ pingUrl = `${baseURL}/ping/ping`, interval = 600000 }) => {
  const [status, setStatus] = useState('good'); // good, moderate, poor, offline
  const [previousStatus, setPreviousStatus] = useState('good'); // Keep track of the previous status

  // Function to measure latency
  const measureLatency = async () => {
    const startTime = Date.now();
    try {
      const response = await api.get(pingUrl); // Axios call to ping endpoint
      const endTime = Date.now();
      return endTime - startTime; // Latency in ms
    } catch (error) {
      return null; // Indicates a failed request
    }
  };

  // Determine network quality
  const getNetworkQuality = (latency) => {
    if (latency === null) {
      return { status: 'offline', message: 'No internet connection' };
    } else if (latency >= 300) {
      return { status: 'poor', message: 'Poor network detected' };
    } else if (latency >= 100) {
      return { status: 'moderate', message: 'Moderate network quality' };
    } else {
      return { status: 'good', message: 'Good network quality' };
    }
  };

  // Monitor network quality
  useEffect(() => {
    const monitorNetworkQuality = async () => {
      const latency = await measureLatency();
      const { status, message } = getNetworkQuality(latency);

      // Show toast notification only on status changes
      if (status !== previousStatus) {
        if (status === 'offline') {
          toast.error(message); // Notify offline
        } else if (status === 'poor' || status === 'moderate') {
          toast(message, { icon: '⚠️' }); // Notify poor or moderate
        } else if (status === 'good' && previousStatus !== 'good') {
          toast.success('You are back online!'); // Notify recovery
        }
        setPreviousStatus(status); // Update the previous status
      }
      setStatus(status); // Update the current status
    };

    // Run periodically
    const intervalId = setInterval(monitorNetworkQuality, interval);

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [pingUrl, interval, previousStatus]);

  return (
    <>
      <Toaster />
    </>
  );
};

export default NetworkStatus;
